import Icon3dIndicator from '../../src/legacy/Icon3dIndicator.tsx';
export default Icon3dIndicator;
